module.exports = "<div id=\"local-loader\"></div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/shared/holders/local-loader/local-loader.com.html
// module id = ./src/app/modules/shared/holders/local-loader/local-loader.com.html
// module chunks = main